import { WithGlobalCss } from "@sgwt-widget/core";

import { ColDef, ColGroupDef, GetMainMenuItemsParams } from "ag-grid-community";
import { LicenseManager } from "ag-grid-enterprise/main";
import { AgGridReact } from "ag-grid-react";
import { ChangeDetectionStrategyType } from "ag-grid-react/lib/changeDetectionService";
import { Component, h } from "preact";
import { AgFormat } from "../../utils/agGridFormat";
import { IHeader } from "./index";
import * as css from "./spl-ag-grid-basic.less";
LicenseManager.setLicenseKey(
  "SHI_International_France__on_behalf_of_SOCIETE_GENERALE_ICT_3Devs9_November_2019__MTU3MzI1NzYwMDAwMA==8f57eed23862f998eb312fb7c1120e18"
);

const cssStyle = {
  displayNone: "display: none;",
};

export interface IProps {
  columnDefs: IHeader[] | any;
  rowData: any[] | any;
  fileName: string;
  groupDefaultExpanded?: number;
  groupIncludeFooter?: boolean;
  groupIncludeHeader?: boolean;
  suppressAggFuncInHeader?: boolean;
  groupSuppressAutoColumn?: boolean;
  showFilterBox?: boolean;
  showExcelToExport?: boolean;
  supressColumnResize?: boolean;
  noDataMessage?: any;
  customHeight?: boolean;
  showToolPanel?: boolean;
  enablePagination?: boolean;
  paginationPageSize?: number;
  paginationAutoPageSize?: boolean;
  suppressPaginationPanel?: boolean;
  gridTitleText?: any;
  showExpand?: boolean;
  userSelection?: { [attribute: string]: string[] | string | {} };
  onChange?: (value: string) => void;
}

export interface IState {
  expanded: boolean;
  userHeader?: IHeader[];
}
export const BasicAgGrid = class extends Component<IProps, IState> {
  private api?: any;
  constructor() {
    super();
    this.api = "";
    this.setState({
      expanded: true,
    });
  }

  public render(): JSX.Element {
    return (
      <WithGlobalCss styles={css}>
        <div style="text-align: center;">
          <div class="text-left row">
            <input
              placeholder="Quick search"
              type="text"
              style={
                this.props.showFilterBox === false
                  ? cssStyle.displayNone
                  : "height: 32px;"
              }
              onInput={(x: any) => this.onQuickFilterText(x)}
              class="col-md-2"
            />
            <button
              style={
                this.props.showExcelToExport === false
                  ? cssStyle.displayNone
                  : "margin-left: 90%;"
              }
              class="btn btn-default col-md-1"
              onClick={() => this.onBtExport()}
            >
              <span class="fa fa-file-excel-o" /> Export
            </button>
            <button
              class="btn btn-default col-md-2"
              style={
                !this.props.showExpand
                  ? cssStyle.displayNone
                  : "margin-left: 10px;"
              }
              onClick={() => this.onBtnExpand()}
            >
              Expand/Collapse
            </button>
          </div>
        </div>

        <div
          style={
            this.props.customHeight === true ? " height: 80%;" : "height: 90%;"
          }
          class={`${css.locals.splAgGridBasic}`}
        >
          <div
            class="ag-theme-bootstrap"
            style={
              this.props.customHeight === true
                ? " height: 80%;"
                : "height: 90%;"
            }
          >
            <AgGridReact
              ref={(agGridReact: any) => {
                this.api = agGridReact;
              }}
              rowDataChangeDetectionStrategy={
                ChangeDetectionStrategyType.NoCheck
              }
              columnDefs={this.buildHeader(this.props.columnDefs)}
              getMainMenuItems={this.getMainMenuItems}
              enableColResize={true}
              enableFilter={true}
              enableSorting={true}
              onGridReady={this.onGridReady.bind(this)}
              rowData={this.props.rowData}
              groupDefaultExpanded={this.props.groupDefaultExpanded}
              groupIncludeFooter={this.props.groupIncludeFooter}
              suppressAggFuncInHeader={this.props.suppressAggFuncInHeader}
              groupSuppressAutoColumn={this.props.groupSuppressAutoColumn}
              overlayLoadingTemplate={this.props.noDataMessage}
              overlayNoRowsTemplate={this.props.noDataMessage}
              suppressContextMenu={true}
              pagination={this.props.enablePagination}
              paginationPageSize={this.props.paginationPageSize}
              paginationAutoPageSize={this.props.paginationAutoPageSize}
              suppressPaginationPanel={this.props.suppressPaginationPanel}
              showToolPanel={this.props.showToolPanel}
              toolPanelSuppressPivots={true}
              toolPanelSuppressPivotMode={true}
              onColumnMoved={this.gridStatusChanged.bind(this)}
              onFilterChanged={this.gridStatusChanged.bind(this)}
              onSortChanged={this.gridStatusChanged.bind(this)}
              onColumnPinned={this.gridStatusChanged.bind(this)}
              onColumnResized={this.gridStatusChanged.bind(this)}
              onColumnVisible={this.gridStatusChanged.bind(this)}
              toolPanelSuppressSideButtons={true}
              sideBar={false}
              excelStyles={[
                {
                  alignment: { horizontal: "Right", vertical: "Bottom" },
                  id: "text-right",
                },
              ]}
            />
          </div>
        </div>
      </WithGlobalCss>
    );
  }

  public componentWillMount() {
    this.setState({
      userHeader: this.loadUserHeader(),
    });
  }

  protected loadUserHeader() {
    const columnDefs = this.props.columnDefs;
    const storedColIds = this.getColIds();

    if (storedColIds.length <= 0) {
      return columnDefs;
    }

    const newColumnDefs: IHeader[] = [];
    for (const colId of storedColIds) {
      const visibleColumn = columnDefs.filter((elem: any) => {
        if (elem.field) {
          return elem.field === colId;
        }
        return elem.showRowGroup === colId;
      })[0];
      if (visibleColumn !== undefined && visibleColumn !== null) {
        visibleColumn.hide = false;
        newColumnDefs.push(visibleColumn);
      }
    }

    for (const column of columnDefs) {
      if (
        !(
          newColumnDefs.filter((elem: any) => elem.field === column.field)
            .length > 0
        )
      ) {
        column.hide = true;
        newColumnDefs.push(column);
      }
    }

    if (newColumnDefs.length > 0) {
      return newColumnDefs;
    }

    return columnDefs;
  }

  protected getColIds() {
    let storedColIds: string[] = [];
    if (
      this.props.userSelection &&
      typeof this.props.userSelection.columns === "string"
    ) {
      const storedState = JSON.parse(this.props.userSelection.columns);

      if (storedState.columnState) {
        storedColIds = this.buildAttributes(
          storedState.columnState
        ) as string[];
      }
    }
    return storedColIds;
  }

  protected onQuickFilterText(event: any) {
    this.api.gridOptions.api.setQuickFilter(event.target.value);
  }

  protected onBtnExpand() {
    this.expandCollapse(!this.state.expanded);
    this.gridStatusChanged();
  }

  private expandCollapse(state: boolean) {
    this.setState({ expanded: state });
    state
      ? this.api.gridOptions.api.expandAll()
      : this.api.gridOptions.api.collapseAll();
  }
  private buildHeader(headerList: IHeader[]): IHeader[] {
    let result = headerList;
    if (
      this.state.userHeader !== null &&
      this.state.userHeader !== undefined &&
      this.state.userHeader.length > 0
    ) {
      result = this.state.userHeader;
    }
    result.forEach(elem => {
      if ((elem as ColGroupDef).children === undefined) {
        const elemColDef = elem as ColDef;
        elemColDef.tooltipValueGetter = AgFormat.ShowCellTooltip;
        elemColDef.headerTooltip = elem.headerName;
        elemColDef.menuTabs = [
          "filterMenuTab",
          "columnsMenuTab",
          "generalMenuTab",
        ];
      }
    });
    return result;
  }

  private getMainMenuItems(params: GetMainMenuItemsParams) {
    params.defaultItems.splice(7); // removed tool panel option
    return params.defaultItems;
  }
  private getUserSelection() {
    if (
      this.props.userSelection &&
      typeof this.props.userSelection.columns === "string"
    ) {
      return JSON.parse(this.props.userSelection.columns);
    }
    return {};
  }

  private onGridReady(params: any) {
    const storedState = this.getUserSelection();
    if (storedState.columnState) {
      storedState.columnState.forEach((x: any) => {
        if (x.pinned) {
          this.api.gridOptions.columnApi.setColumnPinned(x.colId, x.pinned);
        }
        this.api.gridOptions.columnApi.setColumnWidth(
          this.api.gridOptions.columnApi.getColumn(x.colId),
          x.width
        );
      });
    } else {
      params.api.sizeColumnsToFit();
    }
    if (storedState.filterModel) {
      this.api.gridOptions.api.setFilterModel(storedState.filterModel);
    }
    if (storedState.sortModel) {
      this.api.gridOptions.api.setSortModel(storedState.sortModel);
    }
    if (storedState.expandState !== undefined) {
      this.expandCollapse(storedState.expandState);
    }
  }
  private processCellCallback(params: any) {
    if (
      (params.column.filter && params.column.filter === "number") ||
      (params.column.colDef &&
        params.column.colDef.valueGetter === AgFormat.AgGridFormatMoney)
    ) {
      return params.value.replace(/[,%]/g, "").replace(" ", "");
    } else {
      return params.value;
    }
  }

  private onBtExport() {
    const params = {
      allColumns: true,
      columnGroups: true,
      fileName: this.props.fileName || "ag-grid-data",
      onlySelected: false,
      processCellCallback: this.processCellCallback,
      skipFooters: false,
      skipGroups: true,
      skipHeader: false,
      skipPinnedBottom: true,
      skipPinnedTop: true,
    };
    this.api.gridOptions.api.exportDataAsExcel(params);
  }

  private gridStatusChanged() {
    const columnState = this.api.gridOptions.columnApi.getColumnState();
    columnState.forEach((x: any) => {
      if (x.colId === "0") {
        const hiddenColumn = columnState.filter(
          (y: any) => y.rowGroupIndex === 0
        );
        x.colId = hiddenColumn.length > 0 ? hiddenColumn[0].colId : x.colId;
      }
    });
    const filterModel = this.api.gridOptions.api.getFilterModel();
    const sortModel = this.api.gridOptions.api.getSortModel();
    const expandState = this.state.expanded;
    const attrsObj = {
      columnState,
      expandState,
      filterModel,
      sortModel,
    };
    const result = { ...this.getUserSelection(), ...attrsObj };
    const attrs = JSON.stringify(result);
    if (this.props.onChange) {
      this.props.onChange(attrs);
    }
  }
  private buildAttributes(columns: any[]) {
    columns = columns.filter(e => !e.hide);
    return columns.map(x => x.colId);
  }
};
